//load mousetrap
let Mousetrap = require('mousetrap');

//focus on search box
Mousetrap.bind('/', function () {
    let element = document.querySelector('[data-search]');
    element.value = '';
    element.focus();
    return false;
});

//loop over elements
document.querySelectorAll('[data-mousetrap]').forEach(function (element, index) {

    //key combo with spaces
    let combo = element.dataset.mousetrap.split('').join(' ');

    //shift combo
    let shiftCombo = 'shift+' + (index + 1);

    //anchors
    if (element.nodeName.toLowerCase() === 'a') {

        Mousetrap.bind([combo, shiftCombo], function () {
            window.location = element.getAttribute('href');
        });
    }

    //buttons
    else if (element.nodeName.toLowerCase() === 'button') {

        Mousetrap.bind('mod+' + combo, function () {
            element.click();
            return false;
        });
    }

    //inputs
    else if (element.nodeName.toLowerCase() === 'input') {

        Mousetrap.bind(combo, function () {
            element.focus();
        });
    }

});
